export const PATH_ZGT = '/localMerchant/zhiGuangTong'
export const PATH_EDIT_ZGT_PLAN = '/localMerchant/zhiGuangTong/edit'
export const PATH_ZGT_RECHARGE = '/localMerchant/zhiGuangTong/recharge'
export const PATH_ZGT_REWARD = '/localMerchant/zhiGuangTong/reward'
export const PATH_ZGT_STATISTIC = '/localMerchant/zhiGuangTong/subPlanStat'
export const PATH_ZGT_HELP = '/localMerchant/zhiGuangTong/help'

export const EVENT_BUS_GET_PLAN_LIST = 'getPlanList'

// 素材 type, 1，banner；2，启动页；3，视频；4，套餐；5，活动；6，直播；7，单品；8，宴会厅 9店铺 10作品 11图文 12问答 13 视频动态
// 计划 entity_type, 1店铺 2套餐 3作品 4关键字 6活动  21图文动态 22视频动态 23问答 9单品 10宴会厅
// 创意类型
export const MATERIAL_LIST = [
  { id: 1, title: 'banner' },
  { id: 2, title: '启动页' },
  { id: 3, title: '视频' },
  { id: 4, title: '套餐', entity_type: 2 },
  { id: 5, title: '活动', entity_type: 6 },
  { id: 6, title: '直播' },
  { id: 7, title: '单品', entity_type: 9 },
  { id: 8, title: '宴会厅', entity_type: 10 },
  { id: 9, title: '店铺', entity_type: 1 },
  { id: 10, title: '作品', entity_type: 3 },
  { id: 11, title: '图文动态', entity_type: 21 },
  { id: 12, title: '问答', entity_type: 23 },
  { id: 13, title: '视频动态', entity_type: 22 },
  { id: 14, title: '款式', entity_type: 24 }
]

// 1店铺 2套餐 3作品 6活动  9单品 10宴会厅 21图文动态 22视频动态 23问答

export const ENTITY_TYPE_MAP = {
  '1': '店铺',
  '2': '套餐',
  '3': '作品',
  '4': '关键字',
  '6': '活动',
  '9': '单品',
  '10': '宴会厅',
  '21': '图文动态',
  '22': '视频动态',
  '23': '问答',
  '24': '款式'
}

export const MEAL_MATERIAL = [4, 5, 7, 8, 9, 10, 11] // 跟套餐一样有图片和标题

export const CITY_TYPE_COUNTRY = '1'
export const CITY_TYPE_AREA = '4'

export const AREA_MAP = {
  [CITY_TYPE_COUNTRY]: '全国投放',
  '2': '本地+周边城市',
  [CITY_TYPE_AREA]: '区域投放',
  '3': '本地投放'
}

export const STATUS_MAP = {
  '0': '全部',
  '1': '投放中',
  '2': '已暂停',
  '3': '预算不足',
  '4': '异常'
}

export const PLAN_STATUS_OPEN = '1'

export const PLAN_STATUS = {
  '0': '待审核',
  '1': '投放中',
  '2': '暂停',
  '3': '系统停止'
}

export const AD_TYPE_MAP = {
  '0': '全部',
  '1': '精选展位',
  '2': '关键词搜索'
}

export const AD_POSITION_CHOOSE_POSITION = 1 // 精选展位
export const AD_POSITION_KEYWORD = 2 // 关键词搜索
export const EDIT_NUM = 3
export const COMSUME_TYPE = 1
export const TIME_TYPE = 1
export const TIME_VALUE = [9, 18]

export const RECOMMEND_DAY = [4, 5]
export const WEEK_DAY = [
  {
    id: 1,
    title: '周一'
  },
  {
    id: 2,
    title: '周二'
  },
  {
    id: 3,
    title: '周三'
  },
  {
    id: 4,
    title: '周四'
  },
  {
    id: 5,
    title: '周五'
  },
  {
    id: 6,
    title: '周六'
  },
  {
    id: 7,
    title: '周日'
  }
]

export const INITIAL_DAILY_EXTRA_PERCENT = 30
export const INITIAL_MATERIAL_TYPE = 9

export const CUSTOM_PAY_ID = 'custom'
export const TIAN_GONG_ZGT = 43

export const ZGT_RULE = `智优投采用GSP（广义二阶价格拍卖）竞价规则，即排名第N位的出价，在实际投放过程中，将在第N+1位出价的基础上＋1元来扣费（不超过第N位设置的出价）。例如您设置的出价为100元/千次曝光，排在第1位，第2位出价为80元/千次曝光。则在实际投放过程中，按81元/千次曝光来扣费，以此节约您的投放费用。`
export const PAGE_NAME = '推广中心-智优投'
export const STAT = {
  ADD_NEW: 'zyt_new_extend',
  PAY: 'zyt_new_extend_pay_now',
  INTELL_HELP: 'zyt_new_extend_intell_help',
  SUBMIT: 'zyt_new_extend_submit',
  MODIFY_BUDGET: 'zyt_modify_budget',
  EDIT: 'zyt_operate',
  CHECK_DATA: 'zyt_check',
  OPEN: 'zyt_use_or_pause',
  DELETE: 'zyt_delete',
  TG_DATA: 'zyt_extend_data',
  DATA_DL: 'zyt_extend_data_download',
  HELP: 'zyt_use_help',
  INTRO: 'zyt_product_introduction',
  PAY_MONEY: 'zyt_pay_money',
  PAUSE: 'plan_pause',
  START: 'plan_start'
}
